// components/error-page.tsx
"use client";

import { AlertTriangle, Home,RefreshCw } from 'lucide-react';
import Link from 'next/link';
import React from 'react';

import { Button } from './ui/button';

interface ErrorPageProps {
  title?: string;
  message?: string;
  code?: string | number;
  retry?: () => void;
}

export function ErrorPage({
  title = "Something went wrong",
  message = "We're having trouble loading this page. Please try again or go back to the home page.",
  code = "Error",
  retry
}: ErrorPageProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 py-16">
      <div className="text-red-500 mb-6">
        <AlertTriangle size={48} />
      </div>
      
      <h1 className="text-3xl font-bold text-white mb-2">{title}</h1>
      
      <div className="text-lg text-gray-400 mb-4 text-center max-w-md">
        {message}
      </div>
      
      <div className="text-sm text-gray-500 mb-8">
        Error Code: {code}
      </div>
      
      <div className="flex flex-col sm:flex-row gap-4">
        {retry && (
          <Button 
            onClick={retry}
            variant="outline"
            className="flex items-center gap-2"
          >
            <RefreshCw size={16} />
            Try Again
          </Button>
        )}
        
        <Button asChild className="flex items-center gap-2">
          <Link href="/">
            <Home size={16} />
            Return Home
          </Link>
        </Button>
      </div>
    </div>
  );
} 